import * as React from 'react'
import ReadService from "../../../service/read";
import Wait from "../../wait";
import PopDetail from "../../popdetail";
import PlotDetailPane from "../plot/plot_detail_pane";
import {ProjectsService} from "../../../service/v1/projects";
import CreateService from "../../../service/create";
import api from "../../../service/api";


// Modern styling constants
const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
const primaryColor = '#395d9a';
const secondaryColor = '#2bbbad';
const accentColor = '#fbc02d';
const successColor = '#8bc34a';
const dangerColor = '#f44336';
const lightGray = '#f8f9fa';
const borderColor = '#e9ecef';

const containerStyle = {
    fontFamily,
    fontSize: '16px',
    height: '100%',
    background: lightGray,
    overflow: 'hidden'
};

const headerStyle = {
    background: 'linear-gradient(135deg, #395d9a 0%, #2bbbad 100%)',
    color: 'white',
    padding: '16px 24px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '16px'
};

const headerTitleStyle = {
    fontSize: '20px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
};

const filterContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap'
};

const selectStyle = {
    padding: '8px 12px',
    border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: '6px',
    background: 'rgba(255,255,255,0.1)',
    color: 'white',
    fontSize: '14px',
    minWidth: '150px',
    backdropFilter: 'blur(10px)'
};

const buttonStyle = {
    padding: '8px 16px',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.2s ease',
    textDecoration: 'none'
};

const primaryButtonStyle = {
    ...buttonStyle,
    background: 'rgba(255,255,255,0.2)',
    color: 'white',
    border: '1px solid rgba(255,255,255,0.3)'
};

const successButtonStyle = {
    ...buttonStyle,
    background: successColor,
    color: 'white'
};

const cardStyle = {
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    marginBottom: '24px',
    overflow: 'hidden',
    border: `1px solid ${borderColor}`
};

const counterCardStyle = {
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    padding: '20px',
    marginBottom: '16px',
    border: `1px solid ${borderColor}`,
    cursor: 'pointer',
    transition: 'all 0.2s ease'
};

const activeCounterCardStyle = {
    ...counterCardStyle,
    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
    color: 'white',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
};

const counterNumberStyle = {
    fontSize: '32px',
    fontWeight: 700,
    marginBottom: '8px'
};

const counterLabelStyle = {
    fontSize: '14px',
    fontWeight: 500,
    opacity: 0.8
};

const tableContainerStyle = {
    overflowX: 'auto',
    borderRadius: '8px',
    border: `1px solid ${borderColor}`,
    maxHeight: 'calc(100vh - 400px)',
    overflowY: 'auto'
};

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px'
};

const tableHeaderStyle = {
    background: lightGray,
    padding: '12px 16px',
    textAlign: 'left',
    fontWeight: 600,
    color: primaryColor,
    borderBottom: `2px solid ${borderColor}`
};

const tableCellStyle = {
    padding: '12px 16px',
    borderBottom: `1px solid ${borderColor}`,
    verticalAlign: 'top'
};

const actionBarStyle = {
    padding: '16px 20px',
    background: lightGray,
    borderTop: `1px solid ${borderColor}`,
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap'
};

export default class CCROIssuedDataPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            search:'',
            show_actions: this.props.can_edit ? 'table-cell' : 'none',
            totalPages: 1,
            next: null,
            previous: null,
            pageSize: 1000, // Total records to fetch
            displayPageSize: 20, // Records per page for display
            currentPage: 1,
            village_id:0,
            villages:[],
            // New state for filters and counters
            selectedFilter: 'all',
            ageGroupFilter: 'all',

            ageGroups: [
                { label: '18-25', count: 0, key: 'age_18_25' },
                { label: '26-35', count: 0, key: 'age_26_35' },
                { label: '36-45', count: 0, key: 'age_36_45' },
                { label: '46-55', count: 0, key: 'age_46_55' },
                { label: '56+', count: 0, key: 'age_56_plus' }
            ],
            genderGroups: [
                { label: 'Male', count: 0, key: 'male' },
                { label: 'Female', count: 0, key: 'female' }
            ],
            disabilityGroups: [
                { label: 'No Disability', count: 0, key: 'no_disability' },
                { label: 'Physical Disability', count: 0, key: 'physical_disability' },
                { label: 'Visual Disability', count: 0, key: 'visual_disability' },
                { label: 'Hearing Disability', count: 0, key: 'hearing_disability' },
                { label: 'Other Disability', count: 0, key: 'other_disability' }
            ],
            filteredData: [],
            paginatedData: [], // Data for current page display

        }
        this.loadData = this.loadData.bind(this)
        this.searchData = this.searchData.bind(this)
        this.loadLocalities = this.loadLocalities.bind(this)
        this.handleFilterChange = this.handleFilterChange.bind(this)
        this.calculateCounters = this.calculateCounters.bind(this)
        this.updatePagination = this.updatePagination.bind(this)
        this.goToPage = this.goToPage.bind(this)
        this.groupJointOwnershipParties = this.groupJointOwnershipParties.bind(this)
    }

    async componentDidMount() {
        console.log('CCROIssuedDataPane componentDidMount called');
        try {
            Wait.show('Loading Party Information...');
            
            // Try multiple endpoints to get comprehensive data
            let parcelData = [];
            let error = null;
            
            // First try the issued endpoint
            try {
                let url = `projects/parcels/${this.props.project.id}/issued?page_size=1000`;
                if (this.state.village_id && this.state.village_id !== 0) {
                    url += `&village_id=${this.state.village_id}`;
                }
                
                console.log('Trying issued endpoint:', url);
                const response = await api.get(url);
                console.log('Issued endpoint response:', response.data);
                
                if (response.data && response.data.results && response.data.results.length > 0) {
                    parcelData = response.data.results;
                    console.log('Successfully got data from issued endpoint:', parcelData.length, 'records');
                } else {
                    console.log('Issued endpoint returned no data, trying alternative endpoints...');
                }
            } catch (issuedError) {
                console.log('Issued endpoint failed:', issuedError);
            }
            
            // If issued endpoint failed, try the original party-info endpoint
            if (parcelData.length === 0) {
                try {
                    let url = `collect/ccro/parcels/party-info?project_id=${this.props.project.id}`;
                    console.log('Trying party-info endpoint:', url);
                    const response = await api.get(url);
                    console.log('Party-info endpoint response:', response.data);
                    
                    if (response.data && response.data.results && response.data.results.length > 0) {
                        // Convert party-info format to parcel format for consistency
                        parcelData = response.data.results.map(partyInfo => ({
                            registration_no: partyInfo.registration_no,
                            occupancy_type: partyInfo.occupancy_type,
                            party_info: partyInfo.party_name,
                            gender: partyInfo.gender,
                            dob: partyInfo.dob,
                            disability: partyInfo.disability,
                            marital_status: partyInfo.marital_status,
                            parties: [{
                                fullname: partyInfo.party_name,
                                gender: partyInfo.gender,
                                dob: partyInfo.dob,
                                disability: partyInfo.disability,
                                marital: partyInfo.marital_status
                            }]
                        }));
                        console.log('Successfully got data from party-info endpoint:', parcelData.length, 'records');
                    }
                } catch (partyInfoError) {
                    console.log('Party-info endpoint failed:', partyInfoError);
                    error = partyInfoError;
                }
            }
            
            // If both failed, try the registered stage endpoint
            if (parcelData.length === 0) {
                try {
                    let url = `projects/parcels/${this.props.project.id}/registered?page_size=1000`;
                    if (this.state.village_id && this.state.village_id !== 0) {
                        url += `&village_id=${this.state.village_id}`;
                    }
                    
                    console.log('Trying registered endpoint:', url);
                    const response = await api.get(url);
                    console.log('Registered endpoint response:', response.data);
                    
                    if (response.data && response.data.results && response.data.results.length > 0) {
                        parcelData = response.data.results;
                        console.log('Successfully got data from registered endpoint:', parcelData.length, 'records');
                    }
                } catch (registeredError) {
                    console.log('Registered endpoint failed:', registeredError);
                    error = registeredError;
                }
            }
            
            Wait.dismiss();
            
            if (parcelData.length === 0) {
                console.log('No data found from any endpoint');
                this.setState({ 
                    data: [], 
                    filteredData: [], 
                    count: 0, 
                    error: 'No parcel information found for this project. Please check if the project has any CCRO data.' 
                });
            } else {
                console.log('Sample parcel records:', parcelData.slice(0, 3));
                
                // Extract party information from parcel data
                const partyInfoData = this.extractPartyInfoFromParcels(parcelData);
                console.log('Extracted party info data:', partyInfoData);
                console.log('Party info data length:', partyInfoData.length);
                
                // Group joint ownership data
                const groupedData = this.groupJointOwnershipData(partyInfoData);
                console.log('After grouping - groupedData:', groupedData);
                console.log('After grouping - groupedData length:', groupedData.length);
                
                this.setState({
                    data: groupedData,
                    filteredData: groupedData,
                    count: groupedData.length,
                    error: null
                }, () => {
                    console.log('State after setState:', this.state);
                    this.calculateCounters(groupedData);
                    this.filterData();
                });
            }
        } catch (error) {
            Wait.dismiss();
            console.log('Error in componentDidMount:', error);
            console.log('Error response:', error.response);
            console.log('Error response data:', error.response && error.response.data);
            this.setState({ 
                data: [], 
                filteredData: [], 
                count: 0, 
                error: 'Failed to fetch parcel information. Please try again or contact support.' 
            });
        }
        // Only call this if you need to populate the village dropdown,
        // but make sure loadLocalities does NOT call loadData automatically!
        // this.loadLocalities();
    }

    // New method to extract party information from comprehensive parcel data
    extractPartyInfoFromParcels(parcelData) {
        const partyInfoData = [];
        
        parcelData.forEach(parcel => {
            // Extract party information from the parcel data
            const parties = parcel.parties || [];
            const partyInfo = parcel.party_info || [];
            
            // If there are parties array, use that
            if (parties.length > 0) {
                parties.forEach(party => {
                    partyInfoData.push({
                        registration_no: parcel.registration_no,
                        occupancy_type: parcel.occupancy_type || parcel.occupancy_type_name || '',
                        party_name: party.fullname || party.name || party.party_name || 
                                  `${party.first_name || ''} ${party.middle_name || ''} ${party.last_name || ''}`.trim(),
                        gender: party.gender || '',
                        dob: party.dob || '',
                        disability: party.disability || '',
                        marital_status: party.marital || party.marital_status || '',
                        parcel_id: parcel.id,
                        stage: parcel.stage
                    });
                });
            }
            // If there's party_info string, create a record for it
            else if (parcel.party_info && typeof parcel.party_info === 'string') {
                partyInfoData.push({
                    registration_no: parcel.registration_no,
                    occupancy_type: parcel.occupancy_type || parcel.occupancy_type_name || '',
                    party_name: parcel.party_info,
                    gender: parcel.gender || '',
                    dob: parcel.dob || '',
                    disability: parcel.disability || '',
                    marital_status: parcel.marital_status || '',
                    parcel_id: parcel.id,
                    stage: parcel.stage
                });
            }
            // If no party info, still include the parcel with basic info
            else {
                partyInfoData.push({
                    registration_no: parcel.registration_no,
                    occupancy_type: parcel.occupancy_type || parcel.occupancy_type_name || '',
                    party_name: parcel.party_info || 'No party information',
                    gender: '',
                    dob: '',
                    disability: '',
                    marital_status: '',
                    parcel_id: parcel.id,
                    stage: parcel.stage
                });
            }
        });
        
        return partyInfoData;
    }
    
    componentWillUnmount() {
        // Clean up search timeout
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
    }

    groupJointOwnershipParties(data) {
        console.log('Grouping joint ownership parties by registration number...');
        
        // Group by registration number where occupancy type is "pamoja isiyogawanyika"
        const groupedByRegistration = {};
        
        data.forEach(record => {
            const registrationNo = record.registration_no || 'unknown';
            const occupancyType = record.occupancy_type || '';
            
            // Only group if occupancy type is "pamoja isiyogawanyika"
            if (occupancyType.toLowerCase().includes('pamoja isiyogawanyika')) {
                if (!groupedByRegistration[registrationNo]) {
                    groupedByRegistration[registrationNo] = [];
                }
                groupedByRegistration[registrationNo].push(record);
            }
        });
        
        const groupedData = [];
        
        // Process records that should be grouped
        Object.keys(groupedByRegistration).forEach(registrationNo => {
            const parties = groupedByRegistration[registrationNo];
            
            // Only group if there are multiple parties with the same registration number
            if (parties.length > 1) {
                // This is joint ownership - create one record representing all parties
                const firstParty = parties[0];
                
                // Create a combined name for all parties
                const allNames = parties.map(party => {
                    const partyName = (party.first_name && party.last_name ? 
                        `${party.first_name} ${party.middle_name ? party.middle_name + ' ' : ''}${party.last_name}` : 
                        party.first_name || party.last_name || party.middle_name || 
                        party.owner_name || party.party_name || party.name || 'Unknown');
                    return partyName;
                }).filter(name => name !== 'Unknown');
                
                const combinedName = allNames.length > 0 ? 
                    `Joint Ownership: ${allNames.join(', ')}` : 
                    'Joint Ownership (Multiple Parties)';
                
                // Create a single record representing the joint ownership
                const jointOwnershipRecord = {
                    ...firstParty,
                    // Override name fields to show joint ownership
                    first_name: combinedName,
                    middle_name: '',
                    last_name: '',
                    owner_name: combinedName,
                    party_name: combinedName,
                    name: combinedName,
                    full_name: combinedName,
                    // Add joint ownership indicator
                    is_joint_ownership: true,
                    joint_party_count: parties.length,
                    all_parties: parties,
                    // Use the first party's gender, age, etc. for display purposes
                    gender: firstParty.gender || firstParty.owner_gender || 'Male',
                    dob: firstParty.dob || firstParty.date_of_birth || firstParty.owner_date_of_birth || 'N/A',
                    disability: firstParty.disability || firstParty.owner_disability || 'No Disability',
                    marital_status: firstParty.marital_status || firstParty.owner_marital_status || 'N/A',
                    // Keep the registration number for reference
                    registration_no: registrationNo,
                    occupancy_type: firstParty.occupancy_type || 'pamoja isiyogawanyika'
                };
                
                groupedData.push(jointOwnershipRecord);
                console.log(`Grouped ${parties.length} parties under registration ${registrationNo} as joint ownership`);
            } else {
                // Single party with joint ownership type - keep as is
                groupedData.push(parties[0]);
            }
        });
        
        // Add all records that don't have "pamoja isiyogawanyika" occupancy type
        data.forEach(record => {
            const occupancyType = record.occupancy_type || '';
            if (!occupancyType.toLowerCase().includes('pamoja isiyogawanyika')) {
                groupedData.push(record);
            }
        });
        
        console.log(`Grouped data: ${data.length} original records -> ${groupedData.length} grouped records`);
        return groupedData;
    }

    groupJointOwnershipData(data) {
        console.log('Original data length:', data.length);
        console.log('Sample records:', data.slice(0, 3));
        
        // First, let's see what occupancy types we have
        const occupancyTypes = [...new Set(data.map(record => record.occupancy_type))];
        console.log('All occupancy types found:', occupancyTypes);
        
        // Check for registration numbers that appear multiple times
        const registrationCounts = {};
        data.forEach(record => {
            const regNo = record.registration_no;
            registrationCounts[regNo] = (registrationCounts[regNo] || 0) + 1;
        });
        
        const duplicateRegistrations = Object.keys(registrationCounts).filter(regNo => registrationCounts[regNo] > 1);
        console.log('Registration numbers that appear multiple times:', duplicateRegistrations);
        console.log('Registration counts:', registrationCounts);
        
        const groupedData = [];
        const jointOwnershipGroups = {};
        const allGroups = {}; // Group by registration number regardless of occupancy type
        
        // Group records by registration number for joint ownership
        data.forEach(record => {
            const registrationNo = record.registration_no;
            const occupancyType = record.occupancy_type || '';
            
            console.log(`Processing: ${record.party_name} - Reg: ${registrationNo} - Type: ${occupancyType}`);
            
            // Group by registration number regardless of occupancy type
            if (!allGroups[registrationNo]) {
                allGroups[registrationNo] = [];
            }
            allGroups[registrationNo].push(record);
            
            if (occupancyType.toLowerCase().includes('pamoja isiyogawanyika')) {
                if (!jointOwnershipGroups[registrationNo]) {
                    jointOwnershipGroups[registrationNo] = [];
                }
                jointOwnershipGroups[registrationNo].push(record);
            } else {
                // Individual ownership - add directly
                groupedData.push(record);
            }
        });
        
        console.log('Joint ownership groups:', jointOwnershipGroups);
        console.log('All groups by registration number:', allGroups);
        
        // Process joint ownership groups - only group if there are multiple parties
        Object.keys(jointOwnershipGroups).forEach(registrationNo => {
            const parties = jointOwnershipGroups[registrationNo];
            console.log(`Registration ${registrationNo} has ${parties.length} parties:`, parties.map(p => p.party_name));
            
            if (parties.length > 1) {
                // Multiple parties - create a combined record for joint ownership
                const firstParty = parties[0];
                const allPartyNames = parties.map(party => 
                    party.party_name || party.first_name || party.last_name || party.owner_name || party.name || 'Unknown'
                ).filter(name => name !== 'Unknown');
                
                console.log(`Combining parties for ${registrationNo}:`, allPartyNames);
                
                const combinedRecord = {
                    ...firstParty,
                    party_name: allPartyNames.join(' & '),
                    is_joint_ownership: true,
                    joint_party_count: parties.length,
                    all_parties: parties
                };
                
                groupedData.push(combinedRecord);
            } else if (parties.length === 1) {
                // Single party with joint occupancy type - add as individual record
                groupedData.push(parties[0]);
            }
        });
        
        // Also process any registration numbers that have multiple parties regardless of occupancy type
        Object.keys(allGroups).forEach(registrationNo => {
            const parties = allGroups[registrationNo];
            if (parties.length > 1 && !jointOwnershipGroups[registrationNo]) {
                console.log(`Found multiple parties for ${registrationNo} with non-joint occupancy type:`, parties.map(p => p.party_name));
                
                // Check if these are actually different people (not just duplicate records)
                const uniquePartyNames = [...new Set(parties.map(p => p.party_name))];
                if (uniquePartyNames.length > 1) {
                    console.log(`Multiple unique party names for ${registrationNo}:`, uniquePartyNames);
                    
                    // Create a combined record
                    const firstParty = parties[0];
                    const combinedRecord = {
                        ...firstParty,
                        party_name: uniquePartyNames.join(' & '),
                        is_joint_ownership: true,
                        joint_party_count: uniquePartyNames.length,
                        all_parties: parties
                    };
                    
                    // Remove the individual records and add the combined one
                    const existingIndex = groupedData.findIndex(d => d.registration_no === registrationNo);
                    if (existingIndex !== -1) {
                        groupedData.splice(existingIndex, 1);
                    }
                    groupedData.push(combinedRecord);
                }
            }
        });
        
        console.log('Final grouped data length:', groupedData.length);
        console.log('Sample grouped records:', groupedData.slice(0, 3));
        
        return groupedData;
    }


     handleChanges=(e)=>{
        this.setState({
            [e.target.name]:e.target.value
        }, () => {
            // If it's a search input, perform debounced search
            if (e.target.name === 'search') {
                // Clear existing timeout
                if (this.searchTimeout) {
                    clearTimeout(this.searchTimeout);
                }
                
                // Set new timeout for debounced search
                this.searchTimeout = setTimeout(() => {
                    if (!this.state.search.trim()) {
                        // If search is empty, show all data
                        this.setState({ 
                            filteredData: this.state.data,
                            currentPage: 1 // Reset to first page
                        }, () => {
                            this.updatePagination();
                        });
                    } else {
                        // Perform local search for real-time filtering
                        this.performLocalSearch();
                    }
                }, 300); // 300ms delay to reduce search requests
            }
            // If it's a village selection, reload data for that village
            else if (e.target.name === 'village') {
                console.log('Village changed to:', e.target.value);
                if (e.target.value && e.target.value !== '0') {
                    this.loadData();
                } else {
                    // Clear data if no village selected
                    this.setState({
                        data: [],
                        filteredData: [],
                        paginatedData: [],
                        currentPage: 1,
                        totalPages: 1
                    });
                }
            }
        })
    }

    handleFilterChange(filterKey) {
        this.setState({ selectedFilter: filterKey }, () => {
            this.filterData();
        });
    }

    calculateCounters(data) {
        console.log('calculateCounters called with data length:', data.length);
        console.log('Sample data for counters:', data.slice(0, 3));
        
        // Calculate joint ownership count
        const jointOwnershipCount = data.filter(d => d.is_joint_ownership).length;
        const individualCount = data.filter(d => !d.is_joint_ownership).length;
        console.log('Joint ownership count:', jointOwnershipCount);
        console.log('Individual count:', individualCount);
        console.log('Records with is_joint_ownership flag:', data.filter(d => d.is_joint_ownership));
        
        // Calculate age groups
        const ageGroups = [
            { label: '18-25', count: 0, key: 'age_18_25' },
            { label: '26-35', count: 0, key: 'age_26_35' },
            { label: '36-45', count: 0, key: 'age_36_45' },
            { label: '46-55', count: 0, key: 'age_46_55' },
            { label: '56+', count: 0, key: 'age_56_plus' }
        ];

        // Calculate gender groups
        const genderGroups = [
            { label: 'Male', count: 0, key: 'male' },
            { label: 'Female', count: 0, key: 'female' }
        ];

        // Calculate disability groups
        const disabilityGroups = [
            { label: 'No Disability', count: 0, key: 'no_disability' },
            { label: 'Physical Disability', count: 0, key: 'physical_disability' },
            { label: 'Visual Disability', count: 0, key: 'visual_disability' },
            { label: 'Hearing Disability', count: 0, key: 'hearing_disability' },
            { label: 'Other Disability', count: 0, key: 'other_disability' }
        ];

        data.forEach(item => {
            // Age calculation (assuming age field exists)
            const age = item.age || item.owner_age || 30; // Default age if not available
            if (age >= 18 && age <= 25) ageGroups[0].count++;
            else if (age >= 26 && age <= 35) ageGroups[1].count++;
            else if (age >= 36 && age <= 45) ageGroups[2].count++;
            else if (age >= 46 && age <= 55) ageGroups[3].count++;
            else if (age >= 56) ageGroups[4].count++;

            // Gender calculation (assuming gender field exists)
            const gender = item.gender || item.owner_gender || 'male';
            const occupancyType = item.occupancy_type || '';
            
            if (gender.toLowerCase() === 'mwanaume' && occupancyType.toLowerCase().includes('pekee')) {
                genderGroups[0].count++;
            } else if (gender.toLowerCase() === 'mwanamke' && occupancyType.toLowerCase().includes('pekee')) {
                genderGroups[1].count++;
            }

            // Disability calculation (assuming disability field exists)
            const disability = item.disability || item.owner_disability || 'no_disability';
            switch(disability.toLowerCase()) {
                case 'physical':
                    disabilityGroups[1].count++;
                    break;
                case 'visual':
                    disabilityGroups[2].count++;
                    break;
                case 'hearing':
                    disabilityGroups[3].count++;
                    break;
                case 'other':
                    disabilityGroups[4].count++;
                    break;
                default:
                    disabilityGroups[0].count++;
            }
        });

        this.setState({
            ageGroups,
            genderGroups,
            disabilityGroups,
            jointOwnershipCount,
            individualCount
        });
    }

    filterData() {
        const { data, selectedFilter, ageGroupFilter } = this.state;
        let filteredData = data;

        // Apply selected filter
        if (selectedFilter !== 'all') {
            filteredData = data.filter(item => {
                const age = item.age || item.owner_age || 30;
                const gender = item.gender || item.owner_gender || 'male';
                const disability = item.disability || item.owner_disability || 'no_disability';

                switch(selectedFilter) {
                    case 'age_18_25':
                        return age >= 18 && age <= 25;
                    case 'age_26_35':
                        return age >= 26 && age <= 35;
                    case 'age_36_45':
                        return age >= 36 && age <= 45;
                    case 'age_46_55':
                        return age >= 46 && age <= 55;
                    case 'age_56_plus':
                        return age >= 56;
                    case 'male':
                        return gender.toLowerCase() === 'mwanaume' && (item.occupancy_type || '').toLowerCase().includes('pekee');
                    case 'female':
                        return gender.toLowerCase() === 'mwanamke' && (item.occupancy_type || '').toLowerCase().includes('pekee');
                    case 'no_disability':
                        return disability.toLowerCase() === 'no_disability' || !disability;
                    case 'physical_disability':
                        return disability.toLowerCase() === 'physical';
                    case 'visual_disability':
                        return disability.toLowerCase() === 'visual';
                    case 'hearing_disability':
                        return disability.toLowerCase() === 'hearing';
                    case 'other_disability':
                        return disability.toLowerCase() === 'other';
                    default:
                        return true;
                }
            });
        }

        // Apply age group filter
        if (ageGroupFilter !== 'all') {
            filteredData = filteredData.filter(item => {
                // Use the same age calculation as in the table display
                const calculateAge = (dob) => {
                    if (!dob) return item.age || item.owner_age || 30;
                    const birthDate = new Date(dob);
                    const today = new Date();
                    let age = today.getFullYear() - birthDate.getFullYear();
                    const monthDiff = today.getMonth() - birthDate.getMonth();
                    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                        age--;
                    }
                    return age;
                };
                
                const dateOfBirth = item.dob || item.date_of_birth || item.owner_date_of_birth;
                const age = calculateAge(dateOfBirth);
                
                switch(ageGroupFilter) {
                    case 'wazee':
                        return age >= 60;
                    case 'vijana':
                        return age >= 18 && age <= 35;
                    case 'watoto':
                        return age < 18;
                    default:
                        return true;
                }
            });
        }

        this.setState({ filteredData }, () => {
            this.updatePagination();
        });
    }

    updatePagination() {
        const { filteredData, displayPageSize, currentPage } = this.state;
        const totalPages = Math.ceil(filteredData.length / displayPageSize);
        const startIndex = (currentPage - 1) * displayPageSize;
        const endIndex = startIndex + displayPageSize;
        const paginatedData = filteredData.slice(startIndex, endIndex);

        this.setState({
            paginatedData,
            totalPages: Math.max(1, totalPages),
            currentPage: Math.min(currentPage, totalPages)
        });
    }

    goToPage(page) {
        if (page >= 1 && page <= this.state.totalPages) {
            this.setState({ currentPage: page }, () => {
                this.updatePagination();
            });
        }
    }

    loadLocalities() {
        try{
            Wait.show('Loading Villages...')
            ReadService.fetchLocalitiesByProject(this.props.project.id).then(r=>{
                try {
                    let data = r.data.results

                    console.log('Villages loaded:', data)
                    if (data && data.length > 0) {
                    this.setState({
                            villages: data,
                            village_id: data[0].id
                        }, () => {
                            console.log('Village set to:', data[0].id);
                    setTimeout(()=>this.loadData(), 500)
                        })
                    } else {
                        console.log('No villages found');
                        Wait.dismiss();
                    }
                }catch (e) {
                    console.log('Error processing villages:', e)
                    Wait.dismiss();
                }


            }).catch(error => {
                console.log('Error loading villages:', error);
                Wait.dismiss();
            })
        }catch (e) {
            console.log('Error in loadLocalities:', e)
            Wait.dismiss();
        }

    }


    searchData() {
        try {
            if (!this.state.search.trim()) {
                // If search is empty, show all data
                this.setState({ filteredData: this.state.data });
                return;
            }

            Wait.show('Searching....')
            
            // First try to search using the API
            ReadService.searchCCRODataByStage(this.props.project.id, this.state.search.replaceAll('/','_'), this.state.village_id).then(r=>{
                Wait.dismiss()
                const data = r.data.results;
                this.setState({
                    data: data,
                    filteredData: data,
                    totalPages: Math.ceil(r.data.count / this.state.pageSize),
                    next: r.data.next,
                    previous: r.data.previous,
                    count: r.data.count
                })
                this.calculateCounters(data);
                this.filterData();
            }).catch(error => {
                Wait.dismiss()
                console.log('API search failed, using local search:', error);
                // Fallback to local search
                this.performLocalSearch();
            })
        }catch (e) {
            console.log(e)
            // Fallback to local search
            this.performLocalSearch();
        }
    }

    performLocalSearch() {
        const searchTerm = this.state.search.toLowerCase().trim();
        const filteredData = this.state.data.filter(item => {
            const partyName = ((item.first_name && item.last_name ? `${item.first_name} ${item.middle_name ? item.middle_name + ' ' : ''}${item.last_name}` : '') ||
                              item.first_name || item.last_name || item.middle_name ||
                              item.owner_name || item.party_name || item.name || item.full_name || 
                              item.owner?.name || item.party?.name || item.person?.name ||
                              item.owner_info?.name || item.party_info?.name || '').toLowerCase();
            const registrationNo = (item.registration_no || '').toLowerCase();
            const occupancyType = (item.occupancy_type || '').toLowerCase();
            const gender = (item.gender || item.owner_gender || '').toLowerCase();
            const disability = (item.disability || item.owner_disability || '').toLowerCase();
            const maritalStatus = (item.marital_status || item.owner_marital_status || '').toLowerCase();

            return partyName.includes(searchTerm) ||
                   registrationNo.includes(searchTerm) ||
                   occupancyType.includes(searchTerm) ||
                   gender.includes(searchTerm) ||
                   disability.includes(searchTerm) ||
                   maritalStatus.includes(searchTerm);
        });

        this.setState({ 
            filteredData,
            currentPage: 1 // Reset to first page when searching
        }, () => {
            this.updatePagination();
        });
    }

    render() {
        console.log('CCROIssuedDataPane render method called');
        console.log('Current state:', {
            village_id: this.state.village_id,
            villages: this.state.villages.length,
            data: this.state.data.length,
            filteredData: this.state.filteredData.length,
            paginatedData: this.state.paginatedData.length
        });

        return (
            <div style={containerStyle}>

                {/* Village Selection */}
                <div style={{
                    background: 'white',
                    padding: '16px 24px',
                    borderBottom: `1px solid ${borderColor}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    flexWrap: 'wrap'
                }}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                        <select 
                        style={{
                            padding: '8px 12px',
                            border: `1px solid ${borderColor}`,
                            borderRadius: '6px',
                            fontSize: '14px',
                            minWidth: '200px'
                        }} 
                            name={'village'} 
                            onChange={this.handleChanges}
                            value={this.state.village_id}
                        >
                        <option value={0}>- All Villages -</option>
                            {this.state.villages.map((d,i)=>{
                                return(<option value={d.id} key={i}>{d.name}</option>)
                            })}
                        </select>


                    </div>

                    <button style={{
                        padding: '8px 16px',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        transition: 'all 0.2s ease',
                        background: secondaryColor,
                        color: 'white'
                    }} onClick={()=>PopDetail.show('How to Use - Party Information Table',
                        <div style={{padding: '16px', maxWidth: '700px', maxHeight: '60vh', overflowY: 'auto'}}>
                            <h3 style={{color: primaryColor, marginBottom: '16px', fontSize: '18px'}}>
                                <span className={'fa fa-info-circle'} style={{marginRight: '8px'}}/>
                                How to Use the Party Information Table
                            </h3>
                            
                            <div style={{display: 'grid', gap: '12px'}}>
                                <div style={{background: lightGray, padding: '12px', borderRadius: '6px'}}>
                                    <h4 style={{color: primaryColor, marginBottom: '8px', fontSize: '14px'}}>
                                        <span className={'fa fa-search'} style={{marginRight: '8px'}}/>
                                        Searching and Filtering
                                    </h4>
                                    <ul style={{margin: 0, paddingLeft: '16px', fontSize: '13px'}}>
                                        <li>Use the search box to find records by name, registration number, or other details</li>
                                        <li>Select a village from the dropdown to filter by specific village</li>
                                        <li>Use the age group filter to view specific age categories (Wazee, Vijana, Watoto)</li>
                                        <li>Choose records per page (10, 20, 50, or 100) for better viewing</li>
                                    </ul>
                                </div>

                                <div style={{background: lightGray, padding: '12px', borderRadius: '6px'}}>
                                    <h4 style={{color: primaryColor, marginBottom: '8px', fontSize: '14px'}}>
                                        <span className={'fa fa-chart-bar'} style={{marginRight: '8px'}}/>
                                        Summary Statistics
                                    </h4>
                                    <ul style={{margin: 0, paddingLeft: '16px', fontSize: '13px'}}>
                                        <li>View total records count and percentages</li>
                                        <li>See gender distribution (Male/Female) with percentages</li>
                                        <li>Check disability statistics</li>
                                        <li>Monitor joint ownership cases</li>
                                    </ul>
                                </div>

                                <div style={{background: lightGray, padding: '12px', borderRadius: '6px'}}>
                                    <h4 style={{color: primaryColor, marginBottom: '8px', fontSize: '14px'}}>
                                        <span className={'fa fa-table'} style={{marginRight: '8px'}}/>
                                        Table Features
                                    </h4>
                                    <ul style={{margin: 0, paddingLeft: '16px', fontSize: '13px'}}>
                                        <li>Click any row to view detailed party information</li>
                                        <li>For joint ownership (Pamoja Isiyogawanyika), all party names are displayed</li>
                                        <li>Use pagination to navigate through large datasets</li>
                                        <li>Hover over rows for better visibility</li>
                                    </ul>
                                </div>

                                <div style={{background: 'rgba(139, 195, 74, 0.1)', padding: '12px', borderRadius: '6px', border: '1px solid #8bc34a'}}>
                                    <h4 style={{color: '#8bc34a', marginBottom: '8px', fontSize: '14px'}}>
                                        <span className={'fa fa-lightbulb'} style={{marginRight: '8px'}}/>
                                        Tips
                                    </h4>
                                    <ul style={{margin: 0, paddingLeft: '16px', fontSize: '13px'}}>
                                        <li>Start with "All Villages" to see the complete dataset</li>
                                        <li>Use specific village filters for focused analysis</li>
                                        <li>Combine search and filters for precise results</li>
                                        <li>Click on registration numbers to view detailed party information</li>
                                    </ul>
                                </div>
                            </div>
                        </div>)}>
                        <span className={'fa fa-question-circle'}/>Read Me
                    </button>
                </div>

                {/* Main Content */}
                <div style={{padding: '24px', height: 'calc(100vh - 200px)', overflowY: 'auto'}}>
                    
                    {/* Error Display */}
                    {this.state.error && (
                        <div style={{
                            background: '#ffebee',
                            color: '#c62828',
                            padding: '16px',
                            borderRadius: '8px',
                            marginBottom: '16px',
                            border: '1px solid #ffcdd2'
                        }}>
                            <strong>Error:</strong> {this.state.error}
                        </div>
                    )}
                    
                    {/* Summary Statistics */}
                    <div style={{marginBottom: '24px'}}>
                        <h3 style={{marginBottom: '16px', color: primaryColor, fontSize: '18px', fontWeight: 600}}>
                            <span className={'fa fa-users'} style={{marginRight: '8px'}}/>
                            Registered Party Information Summary
                        </h3>
                        


                        <div style={{display: 'flex', gap: '16px', flexWrap: 'wrap'}}>
                            <div style={{
                                background: 'white',
                                padding: '16px 20px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: `1px solid ${borderColor}`,
                                minWidth: '150px'
                            }}>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <div style={{fontSize: '24px', fontWeight: 700, color: primaryColor}}>
                                    {this.state.filteredData.length}
                                    </div>
                                    <div style={{fontSize: '16px', fontWeight: 600, color: primaryColor}}>
                                        100%
                                    </div>
                                    </div>
                                <div style={{fontSize: '14px', color: '#666'}}>Total Records</div>
                                <div style={{fontSize: '12px', color: '#999'}}>
                                    Joint Ownership: {this.state.filteredData.filter(d => d.is_joint_ownership).length} | Individual: {this.state.filteredData.filter(d => !d.is_joint_ownership).length}
                            </div>
                        </div>

                            <div style={{
                                background: 'white',
                                padding: '16px 20px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: `1px solid ${borderColor}`,
                                minWidth: '150px'
                            }}>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <div style={{fontSize: '24px', fontWeight: 700, color: successColor}}>
                                    {this.state.filteredData.filter(d => (d.gender || d.owner_gender || 'male').toLowerCase() === 'mwanaume' && (d.occupancy_type || '').toLowerCase().includes('pekee')).length}
                                    </div>
                                    <div style={{fontSize: '16px', fontWeight: 600, color: successColor}}>
                                        {this.state.filteredData.length > 0 ? 
                                            ((this.state.filteredData.filter(d => (d.gender || d.owner_gender || 'male').toLowerCase() === 'mwanaume' && (d.occupancy_type || '').toLowerCase().includes('pekee')).length / this.state.filteredData.length) * 100).toFixed(1) : '0.0'}%
                                    </div>
                                    </div>
                                <div style={{fontSize: '14px', color: '#666'}}>Male</div>
                            </div>
                            
                            <div style={{
                                background: 'white',
                                padding: '16px 20px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: `1px solid ${borderColor}`,
                                minWidth: '150px'
                            }}>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <div style={{fontSize: '24px', fontWeight: 700, color: '#E91E63'}}>
                                    {this.state.filteredData.filter(d => (d.gender || d.owner_gender || 'male').toLowerCase() === 'mwanamke' && (d.occupancy_type || '').toLowerCase().includes('pekee')).length}
                                    </div>
                                    <div style={{fontSize: '16px', fontWeight: 600, color: '#E91E63'}}>
                                        {this.state.filteredData.length > 0 ? 
                                            ((this.state.filteredData.filter(d => (d.gender || d.owner_gender || 'male').toLowerCase() === 'mwanamke' && (d.occupancy_type || '').toLowerCase().includes('pekee')).length / this.state.filteredData.length) * 100).toFixed(1) : '0.0'}%
                                    </div>
                                </div>
                                <div style={{fontSize: '14px', color: '#666'}}>Female</div>
                        </div>

                            <div style={{
                                background: 'white',
                                padding: '16px 20px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: `1px solid ${borderColor}`,
                                minWidth: '150px'
                            }}>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <div style={{fontSize: '24px', fontWeight: 700, color: dangerColor}}>
                                    {this.state.filteredData.filter(d => {
                                        const disability = d.disability || d.owner_disability || '';
                                        return disability && 
                                               disability.trim() !== '' && 
                                               disability !== 'Hana' && 
                                               disability !== 'N/A' && 
                                               disability.toLowerCase() !== 'na' &&
                                               disability.toLowerCase() !== 'no_disability';
                                    }).length}
                                    </div>
                                    <div style={{fontSize: '16px', fontWeight: 600, color: dangerColor}}>
                                        {this.state.filteredData.length > 0 ? 
                                            ((this.state.filteredData.filter(d => {
                                                const disability = d.disability || d.owner_disability || '';
                                                return disability && 
                                                       disability.trim() !== '' && 
                                                       disability !== 'Hana' && 
                                                       disability !== 'N/A' && 
                                                       disability.toLowerCase() !== 'na' &&
                                                       disability.toLowerCase() !== 'no_disability';
                                            }).length / this.state.filteredData.length) * 100).toFixed(1) : '0.0'}%
                                    </div>
                                    </div>
                                <div style={{fontSize: '14px', color: '#666'}}>With Disability</div>
                            </div>
                            
                            <div style={{
                                background: 'white',
                                padding: '16px 20px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: `1px solid ${borderColor}`,
                                minWidth: '150px'
                            }}>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <div style={{fontSize: '24px', fontWeight: 700, color: '#e67e22'}}>
                                    {(() => {
                                        // Primary method: check is_joint_ownership flag
                                        const jointByFlag = this.state.filteredData.filter(d => d.is_joint_ownership).length;
                                        
                                        // Fallback method: check occupancy type for joint ownership keywords
                                        const jointByType = this.state.filteredData.filter(d => {
                                            const occupancyType = (d.occupancy_type || '').toLowerCase();
                                            return occupancyType.includes('pamoja') || 
                                                   occupancyType.includes('joint') || 
                                                   occupancyType.includes('isiyogawanyika');
                                        }).length;
                                        
                                        // Use the higher count as it's more likely to be accurate
                                        const jointCount = Math.max(jointByFlag, jointByType);
                                        console.log('Joint ownership calculation:', {
                                            byFlag: jointByFlag,
                                            byType: jointByType,
                                            finalCount: jointCount
                                        });
                                        return jointCount;
                                    })()}
                                    </div>
                                    <div style={{fontSize: '16px', fontWeight: 600, color: '#e67e22'}}>
                                        {this.state.filteredData.length > 0 ? 
                                            ((() => {
                                                const jointByFlag = this.state.filteredData.filter(d => d.is_joint_ownership).length;
                                                const jointByType = this.state.filteredData.filter(d => {
                                                    const occupancyType = (d.occupancy_type || '').toLowerCase();
                                                    return occupancyType.includes('pamoja') || 
                                                           occupancyType.includes('joint') || 
                                                           occupancyType.includes('isiyogawanyika');
                                                }).length;
                                                const jointCount = Math.max(jointByFlag, jointByType);
                                                return ((jointCount / this.state.filteredData.length) * 100).toFixed(1);
                                            })()) : '0.0'}%
                                    </div>
                                </div>
                                <div style={{fontSize: '14px', color: '#666'}}>Joint Ownership</div>
                        </div>
                        </div>
                    </div>

                    {/* Search and Actions */}
                    <div style={cardStyle}>
                        <div style={{
                            background: lightGray,
                            padding: '16px 20px',
                            borderBottom: `1px solid ${borderColor}`,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            flexWrap: 'wrap'
                        }}>
                            <div style={{fontSize: '18px', fontWeight: 600, color: primaryColor}}>
                                Showing: {this.state.paginatedData.length} of {this.state.filteredData.length} records (Page {this.state.currentPage} of {this.state.totalPages})
                            </div>
                            
                            <input 
                                name={'search'} 
                                onChange={this.handleChanges} 
                                style={{
                                    padding: '8px 12px',
                                    border: `1px solid ${borderColor}`,
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    minWidth: '300px'
                                }} 
                                placeholder={'Search by name, registration number, village...'}
                            />

                            <button style={successButtonStyle} onClick={()=>this.searchData()}>
                                <span className={'fa fa-search'}/>Search
                            </button>
                            
                            <select 
                                value={this.state.displayPageSize}
                                onChange={(e) => {
                                    this.setState({
                                        displayPageSize: parseInt(e.target.value),
                                        currentPage: 1
                                    }, () => {
                                        this.updatePagination();
                                    });
                                }}
                                style={{
                                    padding: '8px 12px',
                                    border: `1px solid ${borderColor}`,
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    background: 'white'
                                }}
                            >
                                <option value={10}>10 per page</option>
                                <option value={20}>20 per page</option>
                                <option value={50}>50 per page</option>
                                <option value={100}>100 per page</option>
                            </select>
                            
                            <select 
                                value={this.state.ageGroupFilter || 'all'}
                                onChange={(e) => {
                                    this.setState({
                                        ageGroupFilter: e.target.value,
                                        currentPage: 1
                                    }, () => {
                                        this.filterData();
                                    });
                                }}
                                style={{
                                    padding: '8px 12px',
                                    border: `1px solid ${borderColor}`,
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    background: 'white'
                                }}
                            >
                                <option value="all">All Ages</option>
                                <option value="wazee">Wazee (60+)</option>
                                <option value="vijana">Vijana (18-35)</option>
                                <option value="watoto">Watoto (Below 18)</option>
                            </select>
                        </div>

                                                {/* Party Information Table */}
                        <div style={tableContainerStyle}>
                            <table style={tableStyle}>
                                <thead>
                                    <tr>
                                        <th style={{...tableHeaderStyle, width:'50px'}}>#</th>
                                        <th style={tableHeaderStyle}>Name</th>
                                        <th style={tableHeaderStyle}>Gender</th>
                                        <th style={tableHeaderStyle}>Date of Birth</th>
                                        <th style={tableHeaderStyle}>Age</th>
                                        <th style={tableHeaderStyle}>Disability</th>
                                        <th style={tableHeaderStyle}>Marital Status</th>
                                        <th style={tableHeaderStyle}>Occupancy Type</th>
                                        <th style={tableHeaderStyle}>Registration Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.paginatedData.map((d,i)=>{

                                        
                                        // Calculate age from date of birth if available
                                        const calculateAge = (dob) => {
                                            if (!dob) return d.age || d.owner_age || 'N/A';
                                            const birthDate = new Date(dob);
                                            const today = new Date();
                                            let age = today.getFullYear() - birthDate.getFullYear();
                                            const monthDiff = today.getMonth() - birthDate.getMonth();
                                            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                                                age--;
                                            }
                                            return age;
                                        };

                                        const partyName = (d.first_name && d.last_name ? `${d.first_name} ${d.middle_name ? d.middle_name + ' ' : ''}${d.last_name}` : null) ||
                                                         d.first_name || d.last_name || d.middle_name ||
                                                         d.owner_name || d.party_name || d.name || d.full_name || 
                                                         d.owner?.name || d.party?.name || d.person?.name ||
                                                         d.owner_info?.name || d.party_info?.name ||
                                                         'N/A';
                                        const gender = d.gender || d.owner_gender || 'Male';
                                        const dateOfBirth = d.dob || d.date_of_birth || d.owner_date_of_birth || 'N/A';
                                        const age = calculateAge(dateOfBirth);
                                        const disability = d.disability || d.owner_disability || 'No Disability';
                                        const maritalStatus = d.marital_status || d.owner_marital_status || 'N/A';
                                        const occupancyType = d.occupancy_type || 'N/A';
                                        const registrationNo = d.registration_no || 'N/A';

                                        return(<tr key={i}
                                                   style={{
                                                       verticalAlign:'top',
                                                       transition: 'background 0.2s ease'
                                                   }}
                                                   title={`Record ${(this.state.currentPage - 1) * this.state.displayPageSize + i + 1}`}>
                                            <td style={{...tableCellStyle, textAlign: 'center', backgroundColor: 'white'}}>
                                                {(this.state.currentPage - 1) * this.state.displayPageSize + i + 1}
                                            </td>
                                            <td style={tableCellStyle}>
                                                <b style={{color: primaryColor}}>{partyName}</b>
                                                {d.is_joint_ownership && (
                                                    <div style={{
                                                        fontSize: '11px', 
                                                        color: '#e67e22', 
                                                        marginTop: '4px',
                                                        fontWeight: 600,
                                                        background: 'rgba(230, 126, 34, 0.1)',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        display: 'inline-block'
                                                    }}>
                                                        Joint Ownership ({d.joint_party_count} parties)
                                                    </div>
                                                )}
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{
                                                    color: gender.toLowerCase() === 'mwanaume' ? '#2196F3' : '#E91E63',
                                                    fontWeight: 500,
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    background: gender.toLowerCase() === 'mwanaume' ? 'rgba(33, 150, 243, 0.1)' : 'rgba(233, 30, 99, 0.1)'
                                                }}>
                                                    {gender}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{color: '#666', fontFamily: 'monospace'}}>
                                                    {dateOfBirth}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{
                                                    color: primaryColor, 
                                                    fontWeight: 600,
                                                    background: 'rgba(57, 93, 154, 0.1)',
                                                    padding: '2px 6px',
                                                    borderRadius: '4px'
                                                }}>
                                                    {age}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{
                                                    color: disability.toLowerCase() === 'no disability' ? successColor : dangerColor,
                                                    fontWeight: 500,
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    background: disability.toLowerCase() === 'no disability' ? 'rgba(139, 195, 74, 0.1)' : 'rgba(244, 67, 54, 0.1)'
                                                }}>
                                                    {disability}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{
                                                    color: '#666',
                                                    fontWeight: 500
                                                }}>
                                                    {maritalStatus}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{
                                                    color: '#2bbbad',
                                                    fontWeight: 600,
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    background: 'rgba(43, 187, 173, 0.1)',
                                                    fontSize: '13px'
                                                }}>
                                                    {occupancyType}
                                                </span>

                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{
                                                    color: 'darkcyan',
                                                    fontWeight: 600,
                                                    fontFamily: 'monospace',
                                                    fontSize: '13px'
                                                }}>
                                                    {registrationNo}
                                                </span>
                                            </td>
                                        </tr>)
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        {this.state.totalPages > 1 && (
                            <div style={actionBarStyle}>
                                <button 
                                    onClick={() => this.goToPage(this.state.currentPage - 1)}
                                    disabled={this.state.currentPage === 1}
                                    style={{
                                        padding: '8px 16px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        cursor: this.state.currentPage > 1 ? 'pointer' : 'not-allowed',
                                        background: this.state.currentPage > 1 ? '#395d9a' : '#f8f9fa',
                                        color: this.state.currentPage > 1 ? 'white' : '#666',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}
                                >
                                    <span className={'fa fa-chevron-left'}/>Previous
                                </button>
                                
                                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                    <span style={{fontWeight: 600, color: '#395d9a'}}>
                                        Page {this.state.currentPage} of {this.state.totalPages}
                                </span>
                                
                                    {/* Page numbers */}
                                    <div style={{display: 'flex', gap: '4px'}}>
                                        {Array.from({length: Math.min(5, this.state.totalPages)}, (_, i) => {
                                            const pageNum = i + 1;
                                            if (this.state.totalPages <= 5) {
                                                return (
                                                    <button
                                                        key={pageNum}
                                                        onClick={() => this.goToPage(pageNum)}
                                                        style={{
                                                            padding: '4px 8px',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            cursor: 'pointer',
                                                            background: pageNum === this.state.currentPage ? '#395d9a' : '#f8f9fa',
                                                            color: pageNum === this.state.currentPage ? 'white' : '#666'
                                                        }}
                                                    >
                                                        {pageNum}
                                                    </button>
                                                );
                                            } else {
                                                // Show first, last, current, and neighbors
                                                if (pageNum === 1 || pageNum === this.state.totalPages || 
                                                    (pageNum >= this.state.currentPage - 1 && pageNum <= this.state.currentPage + 1)) {
                                                    return (
                                                        <button
                                                            key={pageNum}
                                                            onClick={() => this.goToPage(pageNum)}
                                                            style={{
                                                                padding: '4px 8px',
                                                                border: 'none',
                                                                borderRadius: '4px',
                                                                fontSize: '12px',
                                                                fontWeight: 500,
                                                                cursor: 'pointer',
                                                                background: pageNum === this.state.currentPage ? '#395d9a' : '#f8f9fa',
                                                                color: pageNum === this.state.currentPage ? 'white' : '#666'
                                                            }}
                                                        >
                                                            {pageNum}
                                                        </button>
                                                    );
                                                } else if (pageNum === this.state.currentPage - 2 || pageNum === this.state.currentPage + 2) {
                                                    return <span key={pageNum} style={{color: '#666'}}>...</span>;
                                                }
                                                return null;
                                            }
                                        })}
                                    </div>
                                </div>
                                
                                <button 
                                    onClick={() => this.goToPage(this.state.currentPage + 1)}
                                    disabled={this.state.currentPage === this.state.totalPages}
                                    style={{
                                        padding: '8px 16px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        cursor: this.state.currentPage < this.state.totalPages ? 'pointer' : 'not-allowed',
                                        background: this.state.currentPage < this.state.totalPages ? '#395d9a' : '#f8f9fa',
                                        color: this.state.currentPage < this.state.totalPages ? 'white' : '#666',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}
                                >
                                    Next<span className={'fa fa-chevron-right'}/>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            

        )
    }


    loadData(stage=0) {
        try {
            Wait.show('Fetching Registered and Printed CCROs with Party Information....')
            
            // Function to fetch all pages for a given stage
            const fetchAllPages = async (stage) => {
                let allData = [];
                let nextUrl = null;
                let pageCount = 0;
                
                do {
                    pageCount++;
                    console.log(`Fetching page ${pageCount} for ${stage} stage...`);
                    
                    let response;
                    if (nextUrl) {
                        response = await ProjectsService.fetchProjectsByUrl(nextUrl);
                    } else {
                        // Try to include page size and village parameters in the URL
                        let url = `projects/parcels/${this.props.project.id}/${stage}?page_size=${this.state.pageSize}`;
                        if (this.state.village_id && this.state.village_id !== 0) {
                            url += `&village_id=${this.state.village_id}`;
                        }
                        response = await api.get(url);
                    }
                    
                    const pageData = response.data.results || [];
                    allData = [...allData, ...pageData];
                    nextUrl = response.data.next;
                    
                    console.log(`Page ${pageCount}: ${pageData.length} records, Total so far: ${allData.length}`);
                    console.log('API Response structure:', {
                        count: response.data.count,
                        next: response.data.next,
                        previous: response.data.previous,
                        results: pageData.length
                    });
                    
                } while (nextUrl && pageCount < 10); // Limit to 10 pages to prevent infinite loops
                
                return allData;
            };
            
            // Function to process parcels efficiently using available data
            const processParcelsEfficiently = async (parcels) => {
                console.log(`Processing ${parcels.length} parcels using available data (no additional API calls)`);
                
                const results = [];
                
                parcels.forEach(parcel => {
                    // Extract party info from the parcel data if available
                    const partyInfo = parcel.parties || parcel.party_info || [];
                    const parcelInfo = parcel.parcel_details || parcel.details || null;
                    
                    results.push({ parcel, partyInfo, parcelInfo });
                });
                
                return results;
            };
            
            // Fetch all pages for both registered and printed stages
            Promise.all([
                fetchAllPages('registered'),
                fetchAllPages('printed')
            ]).then(async ([registeredData, printedData]) => {
                // Combine data from both stages
                const combinedData = [...registeredData, ...printedData];
                
                console.log(`Total parcels fetched: ${combinedData.length} (Registered: ${registeredData.length}, Printed: ${printedData.length})`);
                
                // Fetch party information for parcels using batched processing
                Wait.show('Processing parcel data efficiently (no additional API calls)...');
                
                const parcelsWithPartyInfo = [];
                
                // Process parcels efficiently using available data
                const batchResults = await processParcelsEfficiently(combinedData);
                
                // Process the results
                batchResults.forEach(({ parcel, partyInfo, parcelInfo }) => {
                    // Merge basic parcel data with detailed parcel info
                    const detailedParcel = parcelInfo ? { ...parcel, ...parcelInfo } : parcel;
                    
                    // Create a record for each party
                    partyInfo.forEach(party => {
                        parcelsWithPartyInfo.push({
                            ...detailedParcel,
                            party_info: party,
                            // Map party fields to top level for easy access
                            first_name: party.first_name,
                            middle_name: party.middle_name,
                            last_name: party.last_name,
                            gender: party.gender,
                            dob: party.dob,
                            disability: party.disability,
                            marital_status: party.marital_status,
                            phone: party.phone,
                            email: party.email,
                            address: party.address,
                            citizenship_status: party.citizenship_status,
                            id_type: party.id_type,
                            id_no: party.id_no,
                            role_name: party.role_name,
                            acquire: party.acquire
                        });
                    });
                    
                    // If no party info, still include the parcel
                    if (partyInfo.length === 0) {
                        parcelsWithPartyInfo.push(detailedParcel);
                    }
                });
                
                Wait.dismiss();
                
                console.log(`Total records with party info: ${parcelsWithPartyInfo.length}`);
                
                // Debug: Check first few records for name fields
                if (parcelsWithPartyInfo.length > 0) {
                    console.log('Sample records with party info:');
                    parcelsWithPartyInfo.slice(0, 3).forEach((record, index) => {
                        console.log(`Record ${index} keys:`, Object.keys(record));
                        console.log(`Record ${index} party info:`, record.party_info);
                    });
                }
                
                // Group parties with joint ownership by registration number
                const groupedData = this.groupJointOwnershipParties(parcelsWithPartyInfo);
                
                this.setState({
                    data: groupedData,
                    filteredData: groupedData,
                    count: groupedData.length
                }, () => {
                    this.calculateCounters(groupedData);
                    this.filterData();
                });
            }).catch(error => {
                Wait.dismiss()
                console.log('Error fetching CCRO data:', error);
                // Fallback to just issued if the combined fetch fails
                this.loadIssuedCCROs();
            })
        }catch (e) {
            console.log(e)
            // Fallback to just issued if there's an error
            this.loadIssuedCCROs();
        }
    }

    loadIssuedCCROs() {
        try {
            Wait.show('Fetching Issued CCROs....')
            
            // Function to fetch all pages for issued stage
            const fetchAllPages = async () => {
                let allData = [];
                let nextUrl = null;
                let pageCount = 0;
                
                do {
                    pageCount++;
                    console.log(`Fetching page ${pageCount} for issued stage...`);
                    
                    let response;
                    if (nextUrl) {
                        response = await ProjectsService.fetchProjectsByUrl(nextUrl);
                    } else {
                        // Try to include page size and village parameters in the URL
                        let url = `projects/parcels/${this.props.project.id}/issued?page_size=${this.state.pageSize}`;
                        if (this.state.village_id && this.state.village_id !== 0) {
                            url += `&village_id=${this.state.village_id}`;
                        }
                        response = await api.get(url);
                    }
                    
                    const pageData = response.data.results || [];
                    allData = [...allData, ...pageData];
                    nextUrl = response.data.next;
                    
                    console.log(`Page ${pageCount}: ${pageData.length} records, Total so far: ${allData.length}`);
                    
                } while (nextUrl && pageCount < 10); // Limit to 10 pages to prevent infinite loops
                
                return allData;
            };
            
            fetchAllPages().then(data => {
                Wait.dismiss()
                console.log(`Total issued records fetched: ${data.length}`);
                
                // Group parties with joint ownership by registration number
                const groupedData = this.groupJointOwnershipParties(data);
                
                this.setState({
                    data: groupedData,
                    filteredData: groupedData,
                    count: groupedData.length
                }, () => {
                this.calculateCounters(groupedData);
                this.filterData();
                });
            }).catch(error => {
                Wait.dismiss()
                console.log('Error fetching issued CCROs:', error);
            })
        }catch (e) {
            console.log(e)
        }
    }

    fetchProjectsByUrl(url) {
        try {
            Wait.show('Fetching Projects...')
            ProjectsService.fetchProjectsByUrl(url).then(r => {
                Wait.dismiss()
                try {
                    const data = r.data.results;
                    this.setState({
                        data: data,
                        filteredData: data,
                        totalPages: Math.ceil(r.data.count / this.state.pageSize),
                        next: r.data.next,
                        previous: r.data.previous,
                        count: r.data.count
                    })
                    this.calculateCounters(data);
                    this.filterData();
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    downloadExcel(){
        try {
            Wait.show('Generating Party Information Excel Report....')
            let village_id = this.state.village_id
            CreateService.downloadParcelExcel(village_id, 'party_information').then(response => {
                Wait.dismiss()
                const url = window.URL.createObjectURL(new Blob([response.data]));

                // Create a temporary link element
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'registered_party_information.xlsx'); // Specify the filename

                // Simulate a click on the link to trigger the file download
                document.body.appendChild(link);
                link.click();

                // Clean up the temporary objects
                link.remove();
                window.URL.revokeObjectURL(url);

            }).catch(error => {
                Wait.dismiss()
                console.log('Error downloading Excel:', error);
                // Fallback: create a simple CSV download
                this.downloadCSV();
            })
        }catch (e) {
            console.log(e)
            // Fallback: create a simple CSV download
            this.downloadCSV();
        }
    }

    downloadCSV() {
        try {
            const headers = ['Name', 'Gender', 'Date of Birth', 'Age', 'Disability', 'Marital Status', 'Occupancy Type', 'Registration Number'];
            const csvContent = [
                headers.join(','),
                ...this.state.filteredData.map(item => {
                    const partyName = (item.first_name && item.last_name ? `${item.first_name} ${item.middle_name ? item.middle_name + ' ' : ''}${item.last_name}` : null) ||
                                     item.first_name || item.last_name || item.middle_name ||
                                     item.owner_name || item.party_name || item.name || 'N/A';
                    const gender = item.gender || item.owner_gender || 'Male';
                    const dateOfBirth = item.dob || item.date_of_birth || item.owner_date_of_birth || 'N/A';
                    const age = item.age || item.owner_age || 'N/A';
                    const disability = item.disability || item.owner_disability || 'No Disability';
                    const maritalStatus = item.marital_status || item.owner_marital_status || 'N/A';
                    const occupancyType = item.occupancy_type || 'N/A';
                    const registrationNo = item.registration_no || 'N/A';

                    return [
                        `"${partyName}"`,
                        `"${gender}"`,
                        `"${dateOfBirth}"`,
                        `"${age}"`,
                        `"${disability}"`,
                        `"${maritalStatus}"`,
                        `"${occupancyType}"`,
                        `"${registrationNo}"`
                    ].join(',');
                })
            ].join('\n');

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'registered_party_information.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (e) {
            console.log('Error creating CSV:', e);
        }
    }


}
